var map = {
	"./AgentStatement.js": "d911",
	"./MasterStatement.js": "ca86",
	"./PlayerStatement.js": "19bd",
	"./SeniorStatement.js": "a059",
	"./abongCmReportOutStanding.js": "5f6d",
	"./abongReportOutStanding.js": "83dd",
	"./accBank.js": "c8bb",
	"./adminUnit.js": "6bc3",
	"./agent.js": "e909",
	"./agentReports.js": "ea1f",
	"./apongChannel.js": "3716",
	"./auth.js": "446a",
	"./baccaratChannel.js": "35f3",
	"./baccaratCmReportOutStanding.js": "552e",
	"./baccaratReportOutStanding.js": "9639",
	"./betLoto.js": "87de",
	"./betSettings.js": "155f",
	"./cancelBetting.js": "a84f",
	"./changePassword.js": "d982",
	"./channel.js": "36d3",
	"./cockFightChannel.js": "0b8f",
	"./cockFightCmOutstanding.js": "1e4c",
	"./cockFightReportOutStanding.js": "4419",
	"./companyReports.js": "a615",
	"./configApp.js": "1fff",
	"./configUser.js": "70be",
	"./controlStatementByChannel.js": "1fd5",
	"./controllerForManager.js": "857c",
	"./dashboard.js": "986a",
	"./dataStructure.js": "1a23",
	"./dealer.js": "e082",
	"./depositStatement.js": "4eb6",
	"./dragonChannel.js": "c314",
	"./dragonCmReportOutStanding.js": "adcb",
	"./dragonReportOutStanding.js": "d3d5",
	"./enableDisableAgent.js": "2cb2",
	"./enableDisablePlayer.js": "9d2d",
	"./fantanChannel.js": "d0f1",
	"./fantanCmReportOutStanding.js": "df2e",
	"./fantanReportOutStanding.js": "4dda",
	"./generateResult.js": "f36d",
	"./han2CmOutstanding.js": "9fc6",
	"./han2ReportOutStanding.js": "4e08",
	"./han3CmOutstanding.js": "2293",
	"./han3ReportOutStanding.js": "4716",
	"./hanCmOutstanding.js": "526e",
	"./hanReportOutStanding.js": "0d14",
	"./historyByFightReport.js": "596e",
	"./index.js": "b2c6",
	"./klakloukChannel.js": "98bd",
	"./klakloukCmReportOutStanding.js": "3c8b",
	"./klakloukReportOutStanding.js": "9145",
	"./limitBetting.js": "c7b1",
	"./lottoChannel.js": "ff27",
	"./lottoCmReportOutStanding.js": "216f",
	"./lottoReportOutStanding.js": "11b8",
	"./maintenance.js": "867c",
	"./masterReports.js": "7efd",
	"./menu.js": "a9db",
	"./notFound.js": "b9ab",
	"./notification.js": "dac4",
	"./ocControlStatementSummaryPlayerKm.js": "2eaf",
	"./ocControlStatementSummaryPlayerUSD.js": "e354",
	"./ocStatementKh.js": "b697",
	"./ocStatementSummary.js": "1a68",
	"./ocStatementSummaryAgentKm.js": "8de2",
	"./ocStatementSummaryAgentUSD.js": "aaa7",
	"./ocStatementSummaryCompanyKm.js": "9041",
	"./ocStatementSummaryMasterKm.js": "c943",
	"./ocStatementSummaryMasterUSD.js": "327e",
	"./ocStatementSummaryPlayerKm.js": "39bf",
	"./ocStatementSummaryPlayerUSD.js": "96ef",
	"./ocStatementSummarySeniorKm.js": "bb80",
	"./ocStatementSummarySeniorUSD.js": "a402",
	"./ocStatementUsd.js": "d1f1",
	"./organizeStructure.js": "f718",
	"./payOut.js": "bb78",
	"./playerReports.js": "c5b2",
	"./postSettings.js": "65ac",
	"./reverseBaccarat.js": "6951",
	"./reverseCock.js": "5a97",
	"./reverseDragon.js": "d698",
	"./roleLevel.js": "929e",
	"./seniorManagePlayer.js": "3884",
	"./seniorReports.js": "8217",
	"./setOptionOperation.js": "bc92",
	"./setPayout.js": "1fc6",
	"./statement.js": "6bb2",
	"./taisievChannel.js": "ce2e",
	"./taisievCmReportOutStanding.js": "d680",
	"./taisievReportOutStanding.js": "862d",
	"./topRangeWinnerReports.js": "f1cc",
	"./topUp.js": "dae8",
	"./transaction.js": "12b7",
	"./treeStatementKH.js": "8ee7",
	"./treeStatementUSD.js": "9c41",
	"./typeGameSummaryAgent.js": "1c65",
	"./typeGameSummaryCompany.js": "af31",
	"./typeGameSummaryMaster.js": "a6e5",
	"./typeGameSummaryPlayer.js": "99a8",
	"./typeGameSummarySenior.js": "732b",
	"./user.js": "1f93",
	"./userCompanyUnderManager.js": "7f77",
	"./userOnlineReports.js": "60a0",
	"./userPermission.js": "523d",
	"./userRoles.js": "fbe6",
	"./userSubAgent.js": "0d26",
	"./vipPercentage.js": "497f",
	"./weight.js": "ab5a",
	"./widthdrawStatement.js": "8dbe",
	"./yukiChannel.js": "5bf4",
	"./yukiCmReportOutStanding.js": "2792",
	"./yukiReportOutStanding.js": "026f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ced4";